module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "file_025"
    }
  }, [_vm._v("The X stood for experimental. The first F denoted the type of aircraft—a fighter. The second F was the company designation, assigned to the newcomer Grumman Aircraft Engineering Corporation. Logically, Boeing had B and Curtiss held C. However, ")]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("Grumman had lost G because the navy had had previous dealings with the Great Lakes Aeronautical Corporation. Grumman aircraft, including the F6F Hellcat, carried the F designation within their official navy monikers for many years to come.")])]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d49c90e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/file_025.vue
// module id = 126
// module chunks = 0